
const components = {

}

const computed = {
  parkingCarTypes() {
    return _.cloneDeep(this.$store.state.carTypesIframe.locationParkingCarTypes);
  },

  carTypes() {
    return _.cloneDeep(this.$store.state.carTypesIframe.carTypes);
  },

  makes(){
    let carTypes = _.cloneDeep(this.carTypes);
    return Object.keys(carTypes);
  },

  carBodyTypes () {
    return _.cloneDeep(this.$store.state.carTypesIframe.carBodyTypes);
  },

}

const watch = {

  carsData: {
    handler(val) {
      this.$emit("carsDataChanged", val);
    },
    deep: true
  }

}

const methods = {
  clearCarFields(car, trim = false, year = false, model = false) {
    if(trim) {
      car.trims = [];
      car.selectedTrimId= null;
    }
    if(year) {
      car.years = [];
      car.selectedYear= null;
    }
    if(model) {
      car.models = [];
      car.selectedModel= null;
    }
  },

  handleMakeChange(index) {
    let car = this.carsData[index];
    if (car.selectedMake) {
      car.loading = true;
      this.clearCarFields(car, true, true, true);
      let data = {
        index: index,
        value: car.selectedMake,
      }
      let carTypes = _.cloneDeep(this.carTypes)
      car.models = carTypes[car.selectedMake] ? Object.keys(carTypes[car.selectedMake]) : [];
      car.loading = false;
    } else {
      this.clearCarFields(car, true, true, true);
    }
  },

  handleModelChange(index) {
    let car = this.carsData[index];
    if (car.selectedModel) {
      car.loading = true;
      this.clearCarFields(car, true, true);
      let data = {
        index: index,
        value: car.selectedModel,
      }
      let carTypes = _.cloneDeep(this.carTypes)
      car.years = carTypes[car.selectedMake] && carTypes[car.selectedMake][car.selectedModel] ? Object.keys(carTypes[car.selectedMake][car.selectedModel]).reverse() : [];
      car.loading = false; 
    } else {
      this.clearCarFields(car, true, true);
    }
  },

  handleYearChange(index) {
    let car = this.carsData[index];
    if (car.selectedYear) {
      car.loading = true;
      this.clearCarFields(car, true);
      let data = {
        index: index,
        value: car.selectedYear,
      }
      let carTypes = _.cloneDeep(this.carTypes);
      let trims = [];
      if(carTypes[car.selectedMake][car.selectedModel][car.selectedYear] && !carTypes[car.selectedMake][car.selectedModel][car.selectedYear]['all_same']){
        trims = carTypes[car.selectedMake][car.selectedModel][car.selectedYear]['trims'];
        trims = trims.map((trim) => {
          trim = trim.trim().split(',');
          return {
            id: trim[0],
            name: trim[1]
          };
        })
      }
      if(!_.isEmpty(trims) && trims.length > 0) {
        car.trims = trims;
        car.loading = false;
      } else {
        this.clearCarFields(car, true);
        car.loading = false;
      }
    } else {
      this.clearCarFields(car, true);
    }
  },

  handleTrimChange(index) {
    let car = this.carsData[index];
    if (car.selectedTrimId) {
      let data = {
        index: index,
        value: car.selectedTrimId,
      }
    }
  },

  handleUserInputCheckboxChanged(index) {
    let car = this.carsData[index];
    let data = {
      index: index,
      value: car.isUserCarInputs,
    }
  },

  handleUserInputMakeModelChanged(index) {
    let car = this.carsData[index];
    let data = {
      index: index,
      value: car.userCarMakeModelInput,
    }
  },

  handleUserInputCarTypeChanged(index) {
    const bodyType = this.carBodyTypes.find(item => item.id === this.carsData[index].userCarBodyTypeId);
    this.carsData[index].userCarBodyTypeName = bodyType ? bodyType.name : null;
  },

  formatCarsData(carsData, fillOptions = false) {
    let formatted_cars_data = [];
    for (let i = 0; i < carsData.length; i++) {
      let car = carsData[i];
      if (!this.locationId) {
        // this.sendMessage("LocationId is required", 'error', "location_id");
        return false;
      }
      else if (car.isUserCarInputs && (car.userCarMakeModelInput.trim() === "" || car.userCarBodyTypeId === null)) {
        return false;
      }
      else if (!car.isUserCarInputs && (car.selectedMake === null || car.selectedModel === null || car.selectedYear === null)) {
        return false;
      }
      else if (!car.isUserCarInputs && car.trims && car.trims.length > 0 && car.selectedTrimId === null) {
        return false;
      }

      let carTypes = _.cloneDeep(this.carTypes)
      if (car.isUserCarInputs) {
        _.map(this.carBodyTypes, item => {
          if (car.userCarBodyTypeId == item.id) {
            car.userCarBodyTypeName = item.name;
          }
        });
      }
      let carData = {
        isUserCarInputs: car.isUserCarInputs,
        userCarMakeModelInput: car.isUserCarInputs ? car.userCarMakeModelInput : "",
        userCarBodyTypeId: car.isUserCarInputs ? car.userCarBodyTypeId : null,
        userCarBodyTypeName: car.isUserCarInputs ? car.userCarBodyTypeName : null,
        selectedMake: !car.isUserCarInputs ? car.selectedMake : null,
        selectedModel: !car.isUserCarInputs ? car.selectedModel : null,
        selectedYear: !car.isUserCarInputs ? car.selectedYear : null,
        selectedTrimId: !car.isUserCarInputs ? car.selectedTrimId : null,  
      };
      let carTrim = car.selectedTrimId;
      if(!carTrim && !car.isUserCarInputs) {
        carTrim = carTypes[carData.selectedMake][carData.selectedModel][carData.selectedYear]['trims'][0].trim().split(',')[0];
      }
      carData.selectedTrimId = carTrim;

      if(fillOptions) {
        carData.models = carTypes[carData.selectedMake] ? Object.keys(carTypes[carData.selectedMake]) : [];
        carData.years = carTypes[carData.selectedMake] && carTypes[carData.selectedMake][carData.selectedModel] ? Object.keys(carTypes[carData.selectedMake][carData.selectedModel]).reverse() : [];
        let trims = [];
        if(carTypes[carData.selectedMake] && carTypes[carData.selectedMake][carData.selectedModel] && carTypes[carData.selectedMake][carData.selectedModel][carData.selectedYear] && !carTypes[carData.selectedMake][carData.selectedModel][carData.selectedYear]['all_same']){
          trims = carTypes[carData.selectedMake][carData.selectedModel][carData.selectedYear]['trims'];
          trims = trims.map((trim) => {
            trim = trim.trim().split(',');
            return {
              id: trim[0],
              name: trim[1]
            };
          })
        }
        carData.trims = trims;
        if(!carData.isUserCarInputs && carData.trims && carData.trims.length > 0 && carData.selectedTrimId === null) {
          return false;
        }
      }
      formatted_cars_data.push(carData);
    }
    return formatted_cars_data;
  },

  checkNumberInParsedArray(parsedArray, number) {
    for (let i = 0; i < parsedArray.length; i++) {
      let [start, end] = parsedArray[i];
      if (number >= start && number <= end) {
        return true;
      }
    }
    return false;
  },

}


export default {
  name: 'car-types-iframe',
  components,
  computed,
  watch,
  methods,
  props: {
    locationId: {
        type: Number,
        required: true
    },
    numberOfCars: {
        type: Number,
        default: 1
    }
  },  
  data () {
    return {
      loading: true,
      disableSelection: false,
      carsData : [
        {
          isUserCarInputs: false,
          userCarMakeModelInput: "",
          userCarBodyTypeId: null,
          userCarBodyTypeName: null,
          loading:false,
          selectedMake: null,
          selectedModel: null,
          selectedYear: null,
          selectedTrimId: null,  
          models: [],
          years: [],
          trims: [],
        }
      ],
      tempCarsData: []
    }
  },
  mounted () {
    Promise.all([
      this.$store.dispatch('carTypes.getCarTypes'),
      this.$store.dispatch('carTypes.getAllCarBodyTypes'),
      this.$store.dispatch('carTypes.getLocationParkingCarTypes', {location_id: this.locationId})
    ]).then(() => {
      let errors = _.cloneDeep(this.$store.state.carTypesIframe.errors);
      if(!errors) {        
        this.loading = false;
        if(this.tempCarsData && this.tempCarsData.length) {
          let data = this.formatCarsData(this.tempCarsData, true)
          if(!data) {
            // this.sendMessage("Invalid cars data", 'error', "cars_data");
          } else {
            this.carsData = data;
          }  
        }

      } else {
        // this.sendMessage(errors, 'error', "internal_server_error");
      }

    });
  }
}
